import { FEATURES } from 'utils/CustomHooks/useCustomPermission';

export const PERMISSIONS_HIERARCHY = [
  {
    type: 'HEADER',
    title: 'Facilities',
    key: 'FACILITIES',
    permissions: [
      {
        type: 'PERMISSION',
        title: 'CAN_VIEW_FACILITIES',
        group: 'FACILITIES',
      },
      {
        type: 'HEADER',
        title: 'Work Orders',
        key: 'WORK_ORDER',
        permissions: [
          {
            type: 'PERMISSION',
            title: 'CAN_VIEW_WORK_ORDERS',
            group: 'WORK_ORDER',
          },
          {
            type: 'PERMISSION',
            title: 'CAN_ONLY_VIEW_OWN_WORK_ORDERS',
            group: 'WORK_ORDER',
          },
          {
            type: 'PERMISSION',
            title: 'CAN_VIEW_OTHERS_WORK_ORDERS_AT_OWN_LOCATIONS',
            group: 'WORK_ORDER',
          },
          {
            type: 'PERMISSION',
            title: 'CAN_VIEW_OTHERS_WORK_ORDERS',
            group: 'WORK_ORDER',
          },
          {
            type: 'PERMISSION',
            title: 'CAN_MANAGE_WORK_ORDERS',
            group: 'WORK_ORDER',
          },
          {
            type: 'PERMISSION',
            title: 'CAN_CHANGE_WORK_ORDER_STATUS',
            group: 'WORK_ORDER',
          },
          {
            type: 'PERMISSION',
            title: 'CAN_CHANGE_OTHERS_WORK_ORDER_STATUS',
            group: 'WORK_ORDER',
          },
          {
            type: 'HEADER',
            title: 'Work Requests',
            key: 'TASK_REUQEST',
            permissions: [
              {
                type: 'PERMISSION',
                title: 'CAN_VIEW_TASK_REQUESTS',
                group: 'TASK_REUQEST',
              },
              {
                type: 'PERMISSION',
                title: 'CAN_VIEW_OWN_TASK_REQUESTS_ONLY',
                group: 'TASK_REUQEST',
              },
              {
                type: 'PERMISSION',
                title: 'CAN_VIEW_TASK_REQUESTS_IN_AUTHORIZED_LOCATIONS',
                group: 'TASK_REUQEST',
              },
              {
                type: 'PERMISSION',
                title: 'CAN_VIEW_ALL_TASK_REQUESTS',
                group: 'TASK_REUQEST',
              },
              {
                type: 'PERMISSION',
                title: 'CAN_REQUEST_TASK',
                group: 'TASK_REUQEST',
              },
              {
                type: 'PERMISSION',
                title: 'CAN_ACCEPT_DECLINE_TASK_REQUEST',
                group: 'TASK_REUQEST',
              },
              {
                type: 'PERMISSION',
                title: 'CAN_CONFIGURE_PUBLIC_TASK_REQUEST',
                group: 'TASK_REUQEST',
              },
              {
                type: 'HEADER',
                title: 'Routing Rules',
                key: 'ROUTING_RULES',
                permissions: [
                  {
                    type: 'PERMISSION',
                    title: 'CAN_MANAGE_ROUTING_RULES',
                    group: 'ROUTING_RULES',
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];

export const HIDE_LINEAR_GROUPS = [
  'WORK_ORDER',
  'TASK_REUQEST',
  'ROUTING_RULES',
];

export const HIDE_LINEAR_GROUPS_WITH_FEATURE_FLAG = {
  WORK_ORDER: FEATURES.FACILITIES,
  TASK_REUQEST: FEATURES.FACILITIES,
  ROUTING_RULES: FEATURES.FACILITIES,
  FACILITIES: FEATURES.FACILITIES,
};
